export default [
    {
      path: "/accounting/chart-account",
      name: "ChartAccount3PL",
      component: () => import("@/views/3pl/Accounting/ChartAccount/ChartAccount.vue"),
    },
    {
      path: "/accounting/expenditure-tracking",
      name: "ExpenditureTracking",
      component: () => import("@/views/3pl/Accounting/Expenditure/ExpenditureTracking.vue"),
    },
    {
      path: "/accounting/sales",
      name: "AccountingSales",
      component: () => import("@/views/3pl/Accounting/Sales/Sales.vue"),
    },
    {
      path: "/accounting/import-file/:id",
      name: "AccountingImportFiles",
      component: () => import("@/views/3pl/Accounting/Sales/ImportFile.vue"),
    },
    {
      path: "/accounting/tax-input",
      name: "AccountingTaxInput",
      component: () => import("@/views/3pl/Accounting/Tax/TaxInput.ui.vue"),
    },
    {
      path: "/accounting/tax-output",
      name: "AccountingTaxOutput",
      component: () => import("@/views/3pl/Accounting/Tax/TaxOutput.ui.vue"),
    },
    {
      path: "/accounting/tax",
      name: "AccountingTax",
      component: () => import("@/views/3pl/Accounting/Tax/Tax.ui.vue"),
    },
    {
      path: "/accounting/credit-debit",
      name: "AccountingCreditDebit",
      component: () => import("@/views/3pl/Accounting/Credit_Debit/CreditDebit.ui.vue"),
    },
  ];
    